
import { IEntityMetaData, IPropretyAttribute } from "../../../_models/IEntityMetaData";
import { PropretyAttributes, NestedProperty } from "../../../decorators/EntityDecorators";
import { i18nLanguage } from "../i18nLanguage.model";
import { i18nLabel } from "../i18nLabel.model";
import { GenericEntityBase } from "../../../_models/GenericEntityBase";

export class i18nTranslation extends GenericEntityBase<string> {
  private _id?: string = undefined; 
  override get id(): string {
    if (this._id == null) {
      this._id = `${this.fK_i18nLanguage}-${this.fK_i18nLabel}`;
    }
    return this._id;
  }

  override _isRelationEntity = true;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.KeyProperty] })
  fK_i18nLanguage!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.KeyProperty] })
  fK_i18nLabel!: number;

  translation?: string;

  @NestedProperty({ TargetType: i18nLanguage })
  i18nLanguage?: i18nLanguage;

  @NestedProperty({ TargetType: i18nLabel })
  i18nLabel?: i18nLabel;

  GetType(): IEntityMetaData {
    return i18nTranslation.getMetaData();
  }
}
